/* ============================================================
   Choco Crystal — theme.js
   Global UI: menu drawer, cart drawer, quantity steppers.
   Uses event delegation so it keeps working after the Shopify
   theme editor re-renders sections.
   ============================================================ */
(function () {
  'use strict';

  window.cc = window.cc || {};

  var focusTrapStack = [];

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Drawer open / close ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    var overlay = drawer.previousElementSibling && drawer.previousElementSibling.classList.contains('cc-overlay')
      ? drawer.previousElementSibling
      : qs('[data-overlay-for="' + drawer.id + '"]');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = drawer.querySelector('[data-drawer-close], a, button, input');
    if (focusable) focusable.focus();
    focusTrapStack.push(drawer);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    var overlay = qs('[data-overlay-for="' + drawer.id + '"]');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    focusTrapStack = focusTrapStack.filter(function (d) { return d !== drawer; });
  }

  function closeAllDrawers() {
    qsa('.cc-drawer.is-open').forEach(closeDrawer);
  }

  window.cc.openMenu = function () { openDrawer(qs('#cc-menu-drawer')); };
  window.cc.closeMenu = function () { closeDrawer(qs('#cc-menu-drawer')); };
  window.cc.openCartDrawer = function () { openDrawer(qs('#cc-cart-drawer')); };
  window.cc.closeCartDrawer = function () { closeDrawer(qs('#cc-cart-drawer')); };

  /* ---------- Delegated click handling ---------- */
  document.addEventListener('click', function (e) {
    var openMenuBtn = e.target.closest('[data-open-menu]');
    if (openMenuBtn) { e.preventDefault(); window.cc.openMenu(); return; }

    var openCartBtn = e.target.closest('[data-open-cart]');
    if (openCartBtn) {
      // If cart drawer disabled, let the link fall through to /cart
      if (window.cc.settings && window.cc.settings.cartDrawer && qs('#cc-cart-drawer')) {
        e.preventDefault(); window.cc.openCartDrawer(); return;
      }
    }

    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(closeBtn.closest('.cc-drawer')); return; }

    var overlay = e.target.closest('.cc-overlay');
    if (overlay && e.target === overlay) {
      var forId = overlay.getAttribute('data-overlay-for');
      closeDrawer(qs('#' + forId));
      return;
    }
  });

  /* ---------- Esc closes drawers ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  /* ---------- Quantity steppers (generic, delegated) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"], .cc-qty__input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var current = parseInt(input.value, 10) || min;
    var next = Math.max(min, current + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Section-safe re-init hooks (Shopify theme editor) ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    document.dispatchEvent(new CustomEvent('cc:reinit', { detail: { target: e.target } }));
  });
  document.addEventListener('shopify:section:unload', function () {
    document.body.style.overflow = '';
  });
  document.addEventListener('shopify:block:select', function (e) {
    var img = e.target.querySelector('img');
    if (img) img.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  window.cc.utils = { qs: qs, qsa: qsa, openDrawer: openDrawer, closeDrawer: closeDrawer };
})();
